export default {
  M0001: '人员工号为1-50个字母或数字',
  M0002: '人员姓名为1-50个字母或汉字',
  M0003: '当前列表没有数据，无法导出',
  M0004: '导出失败，请重新导出',
  M0005: '密码为6-20位字母数字组合，区分大小写',
  M0006: '密码重置成功',
  M0007: '密码重置失败',
  M0008: '请输入正确的身份证号码',
  M0009: '请输入正确的手机号',
  M0010: '职位最多输入50个字母或汉字',
  M0011: '请输入正确的邮箱地址',
  M0012: '请选择人员角色',
  M0013: '已选择机构不可用',
  M0014: '已选择角色不可用',
  M0015: '员工号重复',
  M0016: '身份证号重复',
  M0017: '手机号重复',
  M0018: '人员信息保存失败',
  M0019: '人员信息保存成功',
  M0020: '帐号异常，请联系管理员',
  M0021: '请选择客户经理',
  M0022: '备注最多输入200个字母或汉字',
  M0023: '您没有权限删除该线索客户',
  M0024: '保存成功',
  M0025: '请填写姓名',
  M0026: '该身份证号对应线索客户已存在',
  M0027: '备注最多输入200个字符',
  M0028: '请输入角色名称',
  M0029: '请选择数据权限',
  M0030: '操作失败，请重试',
  M0031: '成功',
  M0032: '该角色正在使用中，无法删除',
  M0033: (userCount, userName) => `禁用后，使用该角色的所有用户（${userCount}位用户）将失去角色对应的功能权限。确定要禁用“${userName}”角色？`,
  M0034: '人员列表导出数量限制为5000条，请增加筛选条件后再导出',
  M0035: '角色名称已存在',
  M0036: '服务不存在(404)，请联系系统管理员',
  M0037: '服务器繁忙(500)，请稍后再试',
  M0038: '无访问权限，请联系系统管理员',
  M0039: '客户号为1-50个字符',
  M0040: '姓名为1-50个字符',
  M0041: '手机号为1-50个字符',
  M0042: '证件号码为1-50个字符',
  M0043: '请输入正确证件号码',
  M0044: '客户经理姓名为1-50个字符',
  M0045: '请至少选择一条数据',
  M0046: '请选择电访时间',
  M0047: '任务名称输入超出字数限制',
  M0048: '任务描述输入超出字数限制',
  M0049: '新增定时任务成功',
  M0050: '新增定时任务失败 ',
  M0051: '任务正在运行中，请稍后再试 ',
  M0052: count => `已启用${count}条任务`,
  M0053: '请求超时，请重试',
  M0054: '执行失败，请稍后再试',
  M0055: '任务已执行',
  M0056: '操作成功',
  M0057: '操作失败',
  M0058: '启用状态无法删除，请终止后再尝试',
  M0059: '该线索没有手机号，不能制定联络计划',
  M0060: count => `已禁用${count}条任务`,
  M0061: '请选择正确的日期和时间',
  M0062: '此计划已取消，无需重复操作',
  M0063: '线索ID为1-50个字符',
  M0064: '登录已失效，请重新登录',
  M0065: '角色名称不能超过20个字符',
  M0066: '角色描述不能超过200个字符',
  M0067: '只能选择有手机号的线索 ',
  M0068: '定时任务名称重复',
  M0069: '只能选择【未执行】的计划',
  M0070: '请输入字典类别名称',
  M0071: '字典类别名称不能超过20个字符',
  M0072: '字典类别名称已存在',
  M0073: '请输入字典类别标识',
  M0074: '字典类别标识不能超过40个字符',
  M0075: '字典类别标识已存在',
  M0076: '请选择归属菜单',
  M0077: '描述不能超过200个字符',
  M0078: '请输入菜单名称',
  M0079: '菜单名称不能超过20个字符',
  M0080: '菜单名称已存在',
  M0081: '请输入菜单url',
  M0082: '请输入排序值',
  M0083: '排序值仅支持0-999999范围内的整数',
  M0084: '请输入字典项名称',
  M0085: '字典项名称不能超过20个字符 ',
  M0086: '字典项名称已存在',
  M0087: '请输入字典值',
  M0088: '字典值不能超过500个字符',
  M0089: '字典值已存在',
  M0090: '描述不能超过200个字符',
  M0091: '菜单url不能超过200个字符',
  M0092: '路由url不能超过200个字符',
  M0093: '菜单描述不能超过200个字符',
  M0094: '请选择上级菜单',
  M0095: '请选择菜单类型',
  M0096: '该菜单下已有功能权限，无法删除',
  M0097: '请输入功能名称',
  M0098: '功能名称不能超过20个字符',
  M0099: '功能名称已存在',
  M0100: '功能描述不能超过200个字符',
  M0101: '请选择归属菜单/父功能',
  M0102: '该功能权限已被角色使用，无法删除',
  M0103: '该菜单下有子菜单，无法删除。',
  M0104: '该功能下有子功能，无法删除。',
  M0105: '无数据操作权限',
  M0106: '请输入功能url',
  M0107: '功能url不能超过200个字符',
  M0108: '成功',
  M0109: '最多可输入50个字符',
  M0110: '产品简介不能超过1000个字符',
  M0111: '保存定时任务成功',
  M0112: '保存定时任务失败',
  M0113: '产品简介不能超过1000个字符',
  M0114: '话术名称最大可输入50个字',
  M0115: '话术描述最大可输入200个字',
  M0116: '话术详情最大可输入500个字',
  M0117: '话术名称重复',
  M0118: '话术新增成功',
  M0119: '话术保存成功',
  M0120: '该客户没有手机号，不能制定联络计划',
  M0121: '只能选择有手机号的客户',
  M0122: 'Cron表达式不符合规范',
  M0123: '任务路径最大可输入200个字',
  M0124: '题目名称最多可输入100个字',
  M0125: '答案数量超出限制',
  M0126: '答案内容最多可输入100个字',
  M0127: '题目名称重复',
  M0128: '题目新增成功',
  M0129: '删除成功',
  M0130: '删除失败',
  M0131: '题目所属问卷正在使用中，请禁用问卷后再操作',
  M0132: '问卷名称最多可输入100个字',
  M0133: '问卷名称重复',
  M0134: '测评标准超出数量限制',
  M0135: '测评标准填写错误',
  M0136: '问卷保存成功',
  M0137: '删除成功',
  M0138: '删除失败',
  M0139: '问卷正在使用中，请禁用后再编辑',
  M0140: '请输入必填项',
  M0141: '',
  M0142: '',
  M0143: '设备ID不能超过50个字符',
  M0144: '机构代码不能超过50个字符',
  M0145: '交易柜员号不能超过50个字符',
  M0146: '请输入设备ID',
  M0147: '设备ID已存在',
  M0148: '请输入机构代码',
  M0149: '请输入正确的机构代码',
  M0150: '请输入交易柜员号',
  M0151: '请输入外屏IP地址',
  M0152: '请输入正确的IP格式',
  M0153: 'IP已存在',
  M0154: '设备MAC不能超过50个字符',
  M0155: '负责人不能超过50个字符',
  M0156: '备注不能超过200字符',
  M0157: '新增成功',
  M0158: '修改成功',
  M0159: '确定要删除该终端维护记录吗？',
  M0160: '删除成功',
  M0161: '终端未注册，请注册',
  M0162: '账号已冻结，请联系管理员',
  M0163: '账号已注销，请联系管理员',
  M0164: '账号或密码错误，请重试',
  M0165: '设备ID不能超过50个字符',
  M0166: '请输入设备ID',
  M0167: '终端注册成功',
  M0168: '产品代码不能超过50个字符',
  M0169: '产品名称不能超过50个字符',
  M0170: '附件名称不能超过50个字符',
  M0171: '请选择产品附件',
  M0172: '请上传文件',
  M0173: '上传文件格式不正确，仅支持PDF',
  M0174: '上传文件大小不能超过20M',
  M0175: '请输入附件名称',
  M0176: '附件名称不能超过50个字符',
  M0177: '展示顺序不能超过50个字符，且仅支持数字',
  M0178: '新增成功',
  M0179: '确定要修改该公共附件吗？',
  M0180: '修改成功',
  M0181: '确定要删除该公共附件吗？',
  M0182: '删除成功',
  M0183: '启用后，用户购买该产品类型下任意产品时，外屏将显示该附件，确定要启用吗？',
  M0184: '启用成功',
  M0185: '禁用后，用户购买该产品类型下任意产品时，外屏将不再显示该附件，确定要禁用吗？',
  M0186: '禁用成功',
  M0187: '新增成功',
  M0188: '确定要修改该个性化附件吗？',
  M0189: '修改成功',
  M0190: '确定要删除该个性化附件吗？',
  M0191: '删除成功',
  M0192: '启用后，用户购买该产品时，外屏将显示该附件，确定要启用吗？',
  M0193: '启用成功',
  M0194: '禁用后，用户购买该产品时，外屏将不再显示该附件，确定要禁用吗？',
  M0195: '禁用成功',
  M0196: '问卷题目丢失，请返回上一步重新添加',
  M0197: '启用成功',
  M0198: '禁用成功',
  M0199: '',
  M0200: '',
  M0201: '题目保存成功',
  M0213: '只能输入数字',
  M0214: '请选择机构',
  M0215: '当前机构已有双录参数',
  M0216: '请输入IP地址',
  M0217: '请输入端口号',
  M0218: '请输入FTP路径',
  M0219: '请输入FTP用户名',
  M0220: '请输入密码',
};
